import { PAGE_KEY } from './constants';

export const en = {
  [PAGE_KEY]: {
    TITLE: 'Succession Coverage',
    DESCRIPTION:
      'Monitor which positions have identified successors and detect risks in talent continuity to ensure the stability and sustainability of leadership in the organization',
    PERFORMANCE: 'Performance',
    SUCCESSION_COVERAGE: 'Succession Coverage',
    TABLE_TITLE: 'Positions',
    SEARCH_PLACEHOLDER: 'Search positions',
    CRITICALITY_HIGH: 'High',
    CRITICALITY_MEDIUM: 'Medium',
    CRITICALITY_LOW: 'Low',
    SUCCESSOR_COVERED: 'Covered',
    SUCCESSOR_NO_SUCCESSOR: 'No successor',
    AI_SUGGESTIONS_TOOLTIP:
      'AI-identified candidates: This position has suggestions generated based on the position profile and defined criteria.',
    HIGH_RISK_TOOLTIP:
      'High risk: This position is highly critical and currently has no confirmed successor or identified candidates. It is recommended to prioritize its coverage.',
    COLUMN_POSITION: 'Position',
    COLUMN_CRITICALITY: 'Criticality',
    COLUMN_SUGGESTED_CANDIDATES: 'Suggested candidates',
    COLUMN_CONFIRMED_SUCCESSOR: 'Confirmed successor',
    TOOLTIP_VIEW_POSITION_DETAIL: 'View position details',
    ALERT_SELECTED_RECORD: 'Selected record: {{id}}',
    ERROR_TITLE: 'An error occurred while loading',
    ERROR_DESCRIPTION: 'Click the button to try loading again.',
    ERROR_RETRY_BUTTON: 'Retry',
    TOTAL_COVERAGE_TITLE: 'Total succession coverage',
    COVERED_POSITIONS: 'positions covered',
    PRIORITY_HIGH: 'High',
    PRIORITY_MEDIUM: 'Medium',
    PRIORITY_LOW: 'Low',
    POSITIONS_WITHOUT_COVERAGE: 'Positions without coverage',
    POSITIONS_COUNT: 'positions',
    VIEW_POSITIONS_AT_RISK: 'View positions at risk',
    LAST_UPDATE: 'Last update on',
    POSITIONS_WITH_CONFIRMED_SUCCESSOR: 'Positions with confirmed successor',
    VIEW_COVERED_POSITIONS: 'View covered positions',
    OF: 'of',
    EMPTY_TABLE_TITLE: 'No positions available',
    EMPTY_TABLE_SUBTITLE: 'No positions were found matching your search.',
  },
};
